export default __webpack_public_path__ + "static/media/clearance-grey.58ed7c82.svg";